/**
 * @file LockedScreenRow.tsx
 * @description Закреплённая строка экрана магазина в структуре (phase19.16
 * Р2 «Лента статей», Р2а «Список товаров», uiux-design-r2a §2): замок —
 * строку нельзя переместить или удалить; нажатие открывает панель вида.
 */

import { ChevronRight, Lock } from "lucide-react";

export function LockedScreenRow({ label, onOpen }: { label: string; onOpen: () => void }) {
  return (
    <button
      type="button"
      onClick={onOpen}
      className="flex min-h-12 items-center gap-2 rounded-lg bg-surface-low px-3 text-left outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <Lock aria-label="Закреплено" className="size-4 shrink-0 text-on-surface-variant" />
      <span className="type-body flex-1 text-on-surface">{label}</span>
      <ChevronRight aria-hidden className="size-4 shrink-0 text-on-surface-variant" />
    </button>
  );
}
